module.exports = __webpack_public_path__ + "static/img/1-1.92eaab8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/1-1.png
// module id = HKaW
// module chunks = 0